import { types as coreTypes } from '@sitebuilder/core';

const schema: coreTypes.Schema = {
    enablePagination: {
        type: 'boolean',
        title: 'Enable Pagination',
        description: '',
    },
};

const dependencies: coreTypes.Schema = {
    enablePagination: {
        oneOf: [
            {
                properties: {
                    enablePagination: { enum: [true] },
                    defaultPageSize: {
                        type: 'number',
                        title: 'Default Page Size',
                        default: 10,
                        description: 'Enter a number',
                    },
                    pagerButtonStyle: {
                        type: 'string',
                        title: 'Pager Button Style',
                        enum: ['rectangle', 'circle'],
                        default: 'circle',
                    },
                    showPageSizePicker: {
                        type: 'boolean',
                        title: 'Show Page Size Picker',
                        description: '',
                    },
                    showCurrentPageText: {
                        type: 'boolean',
                        title: 'Show Current Page Text',
                        description: '',
                    },
                    pagingType: {
                        type: 'string',
                        title: 'Type of Paging',
                        enum: [
                            'numbers',
                            'simple',
                            'simple_numbers',
                            'full',
                            'full_numbers',
                            'first_last_numbers',
                        ],
                        default: 'simple_numbers',
                    },
                    pagePickerPosition: {
                        type: 'string',
                        title: 'Page Picker Position',
                        enum: ['left', 'right', 'center'],
                        default: 'right',
                    },
                    pagePickerDropdownImage: {
                        type: 'string',
                        title: 'Page Picker Dropdown Icon',
                    },
                    previousBtnText: {
                        type: 'string',
                        title: 'Previous Button Text',
                    },
                    nextBtnText: {
                        type: 'string',
                        title: 'Next Button Text',
                    },
                    firstBtnText: {
                        type: 'string',
                        title: 'First Button Text',
                    },
                    lastBtnText: {
                        type: 'string',
                        title: 'Last Button Text',
                    },
                },
            },
            {
                properties: {
                    enablePagination: { enum: [false] },
                },
            },
        ],
    },
    showPageSizePicker: {
        oneOf: [
            {
                properties: {
                    showPageSizePicker: { enum: [true] },
                    configurePageSizes: {
                        type: 'string',
                        title: 'Configure Page Sizes',
                        description: 'Enter page sizes seperated by comma',
                        default: '10,20,50,100',
                    },
                    enableShowAll: {
                        type: 'boolean',
                        title: 'Enable Show All',
                        description: 'Show all records in one page',
                    },
                    showAllText: {
                        type: 'string',
                        title: 'Show All Text',
                        description: 'Text for show all button',
                        default: 'All',
                    },
                    pageSizePickerPosition: {
                        type: 'string',
                        title: 'Page Size Picker Position',
                        enum: ['left', 'right', 'center'],
                        default: 'left',
                    },
                    pagePickerDropdownImage: {
                        type: 'string',
                        title: 'Page Picker Dropdown Icon',
                    },
                    pageSizePickerText: {
                        type: 'string',
                        title: 'Page size picker helper text',
                        default: '',
                    },
                },
            },
            {
                properties: {
                    showPageSizePicker: { enum: [false] },
                },
            },
        ],
    },
    showCurrentPageText: {
        oneOf: [
            {
                properties: {
                    showCurrentPageText: { enum: [true] },
                    currentPageText: {
                        type: 'string',
                        title: 'Current page Text',
                        default: '{{ pageFrom }} - {{ pageTo }} of {{ pageTotalCount }}',
                        description:
                            // eslint-disable-next-line max-len
                            'Use a format similar to this {{ pageFrom }} - {{ pageTo }} of {{ pageTotalCount }}',
                    },
                    currentPageTextPosition: {
                        type: 'string',
                        title: 'Current Page Text Position',
                        enum: ['left', 'right', 'center'],
                        default: 'left',
                    },
                },
            },
            {
                properties: {
                    showPageSizePicker: { enum: [false] },
                },
            },
        ],
    },
};

const uiSchema = {
    'ui:order': [
        'enablePagination',
        'defaultPageSize',
        'pagerButtonStyle',
        'showPageSizePicker',
        'configurePageSizes',
        'enableShowAll',
        'showAllText',
        'pageSizePickerPosition',
        'pageSizePickerText',
        'showCurrentPageText',
        'currentPageText',
        'currentPageTextPosition',
        'pagingType',
        'pagePickerPosition',
        'pagePickerDropdownImage',
        'previousBtnText',
        'nextBtnText',
        'firstBtnText',
        'lastBtnText',
        '*',
    ],
    enablePagination: { 'ui:widget': 'CustomCheckbox' },
    showPageSizePicker: { 'ui:widget': 'CustomCheckbox' },
    configurePageSizes: { 'ui:widget': 'CustomTextInput' },
    pageSizePickerPosition: { 'ui:widget': 'CustomSelect' },
    showCurrentPageText: { 'ui:widget': 'CustomCheckbox' },
    currentPageText: { 'ui:widget': 'ResourcePicker' },
    currentPageTextPosition: { 'ui:widget': 'CustomSelect' },
    pagingType: { 'ui:widget': 'CustomSelect' },
    enableShowAll: { 'ui:widget': 'CustomCheckbox' },
    showAllText: { 'ui:widget': 'ResourcePicker' },
    pagePickerPosition: { 'ui:widget': 'CustomSelect' },
    defaultPageSize: { 'ui:widget': 'CustomTextInput' },
    pagerButtonStyle: { 'ui:widget': 'CustomSelect' },
    previousBtnText: { 'ui:widget': 'ResourcePicker' },
    nextBtnText: { 'ui:widget': 'ResourcePicker' },
    firstBtnText: { 'ui:widget': 'ResourcePicker' },
    lastBtnText: { 'ui:widget': 'ResourcePicker' },
    pageSizePickerText: { 'ui:widget': 'ResourcePicker' },
    pagePickerDropdownImage: {
        'ui:placeholder': 'https://',
        'ui:widget': 'MediaPicker',
        'ui:options': {
            isImagePicker: true,
        },
    },
};

const paginationSchema = {
    schema,
    uiSchema,
    dependencies,
};

export default paginationSchema;
